import React from 'react';


type HoverRevealProps = {
  always_revealed: boolean,
  placeholder?: string,
}
type HoverRevealState = {
  revealed: boolean,
};
class HoverRevealComponent extends React.Component<HoverRevealProps, HoverRevealState> {
	constructor(props: HoverRevealProps) {
		super(props);
		this.state = {
			revealed: props.always_revealed,
		};
	}

  componentDidUpdate(prevProps: HoverRevealProps) {
    if (prevProps.always_revealed !== this.props.always_revealed && this.state.revealed !== this.props.always_revealed) {
      this.setState({
        revealed: this.props.always_revealed,
      })
    }
  }


	render() {
		const { revealed } = this.state;

		return (
			<div className="box">
        <div className="boxTitle"
          onMouseEnter={() => this.setState({ revealed: this.props.always_revealed || !revealed, })}
          onMouseLeave={() => this.setState({ revealed: this.props.always_revealed || !revealed, })}
        >
              {
              revealed ? this.props.children :
                <div className="center">
                <i>
                {(this.props.placeholder || "Hover to reveal")}
                </i>
                </div>
              }
				</div>
			</div>
		);
	}
}

export default HoverRevealComponent;
